<template lang="html">
  
      <div class="container">
  
        <h3 class="subtitle-section">Otros estudios</h3>
  
        <div class="contenedor-experiencias" v-if="!showedit">
          <academico :data="academico" :key="key" v-for="(academico,key) in cvacademicos" v-if="!!cvacademicos"></academico>
          <p v-if="isAlumni & !!!cvacademicos" class="zero-results">No tienes ningún dato académico realizado en otro centro añadido pulsa <a @click="showedit = true">editar</a> para añadirlo</p>
        </div>
  
        <div class="contenedor-experiencias" v-if="showedit">
  
          <academico-edit @erase="eraseacademico" v-model="academicoedit[key]" :propio="false" :data="academico" :key="key+'edit'" v-for="(academico,key) in cvacademicos" :clicked="true"></academico-edit>
  
          <academico-edit :propio="false" :clicked="clicked" @erase="eraseNewacademico" v-model="newacademicos[el-1]" v-if="newacademicoslength != 0" :key="key+'new'" v-for="(el,key) in newacademicoslength"></academico-edit>
  
          <button v-if="!shownew" @click="newacademicoslength++" class="add-btn
                -newexperiencia">Añadir nuevo</button>
        </div>
    
  
      </div>

  
  </template>
  
  <script lang="js">
  
    import academico from '@/components/parts/academico-el';
    import academicoedit from '@/components/parts/academico-edit';
  
    import {mapGetters, mapActions} from 'vuex'


  
    export default {
      name: 'otros-estudios',
      props : ['cvacademicos','showedit'],
      data() {
        return {
          shownew : false,
          clicked : false,
          newacademicos : [],
          newacademicoslength : 0,
          academicoedit : [],
          loading: false,
        }
      },
      computed : {
        ...mapGetters({
          isEstudiante : 'isEstudiante',
          isAlumni : 'isAlumni'
        })
      },
      components: {
        'academico': academico,
        'academico-edit': academicoedit
      },
      methods: {
        ...mapActions(['editOtroEstudio','requestCV']),
        showEdit(){
          if(!!this.isAlumni){
            this.showedit = !this.showedit;
          }
        },
        eraseacademico(value){
          this.academicosedit = (!!this.cvacademicos) ? this.cvacademicos : [];
          this.showedit = false;
        },
        eraseNewacademico(value){
          this.newacademicos = this.newacademicos.filter(e => e.idTitulacion != value.idTitulacion);
          this.newacademicoslength--;
        },
        saveData(){
  
            this.clicked = true;
  
            if(this.academicoedit.every(e => e.allok)  &  this.newacademicos.every(e => e.allok)){
  
              this.academicoedit = this.academicoedit.concat(this.newacademicos);
  
              if(this.academicoedit.length != 0){
  
                this.loading = true;
  
                this.academicoedit.forEach((e,key) => {
                  this.editOtroEstudio(e).then(r => {
                    if(key+1 == this.academicoedit.length){
                      this.shownew = false;
                      this.loading = false;
                      this.newacademicos = [];
                      this.newacademicoslength = 0;
                      this.clicked = false;
                      this.requestCV();
                    }
                  })
                });
  
              }
  
            }else{
              this.clicked = true;
              this.loadingExperiencia = false;
            }
        }
      },
      watch : {
        'showedit'(){
          this.academicoedit = (!!this.cvacademicos) ? this.cvacademicos : [];
        },
        'cvacademicos': {
            deep: true,
            handler(){
              this.academicoedit = (!!this.cvacademicos) ? this.cvacademicos : [];
            }
        }
      }
    }
  </script>
  
  <style scoped lang="scss">
  
    .add-btn{
      margin-bottom: 25px;
    }
  
  </style>


// WEBPACK FOOTER //
// src/components/view-parts/espacio-personal/otros-estudios.vue